<!---    https://xd.adobe.com/view/76b4cb5f-95f1-4983-8133-a70dfe9ef3e0-23e7/screen/1778424e-59cc-4dff-b8c4-9bd1c4a98aef/specs/   -->
<template>
  <div id="checkpayproff" >
    <AppModal v-model="isverified" position="center" :no-close-on-backdrop="true">
          <div class="py1" ></div>
          <div class="white-background  m2">
            <div class="white-background  my2">
                <div class="flex flex-col w-100 py2 m0 items-start " >
                  <div class="block">
                    <p class="fs-16 regular">Dit IBAN-nummer sikrer, at dine betalinger behandles hurtigt og korrekt.</p>
                    <div class="m0 w-100 px0 py2" v-if="!partnerwallet || partnerwallet.IBAN === null || partnerwallet.IBAN === ''">
                      <label class="p0 m0 font12" for="partneribannew"><span class="red">*</span>Iban-nummer</label>
                      <div class="flex">
                        <select v-model="selectedCountry" class="white-background" style="width: auto;">
                          <option :value="index" v-for="(country,index) in countryData" :key="index">{{country + ' - ' + index}}</option>
                        </select>
                        <input placeholder="XXXXXXXXXXXXXXXXXX" v-model="partneriban" class="white-background w-100" />
                      </div>
                      <label class="error red fs-16 small" v-if="ibanmessage">{{ibanmessage}}</label>
                    </div>
                  </div>
                  <button @click="updateStatus('clicked')" :disabled="disablebutton" class="ml-auto my1 px2 action-button white no-borde flex justify-center items-center rounded-6">
                    <span class="mx2 my1">Godkend med MitID</span>
                  </button>
                </div>
              </div>
          </div>
    </AppModal>
    <ErrorHandler ref="errorMsg"></ErrorHandler>
  </div>
</template>
<script setup>
import { ref, watch } from 'vue'
import axios from 'axios'
import AppModal from '@/components/AppModal.vue'
import ErrorHandler from '@/components/ErrorHandler'
import countryData from '@/components/countries.json'

// State
const salesPersonbitrix = ref('')
const haaId = ref('')
const partnername = ref('')
const defaultpackage = ref([])
const haspayproff = ref(false)
const ispartnerpayproffverified = ref(false)
const isverified = ref(false)
const verifylink = ref('')
const payproffform = ref(false)
const confirmPayproff = ref(false)
const partnerwallet = ref({})
const partneriban = ref('')
const ibanmessage = ref(null)
const payproffemail = ref('')
const clickdate = ref('')
const disablebutton = ref(false)
const selectedCountry = ref('DK')
const errorMsg = ref(null)

// Created logic
salesPersonbitrix.value = localStorage.getItem('id_token_portalbitrix')
haaId.value = localStorage.getItem('haaid')
partnername.value = localStorage.getItem('CompanyName')

// Watch
watch(partneriban, (newVal) => {
    setTimeout(() => {
        if (newVal.length > 1) {
            setmaskinput(newVal)
        }
    }, 300)
})

// Methods
function showlink () {
    window.open(verifylink.value, '_blank').focus()
}

function verifypartner () {
    salesPersonbitrix.value = localStorage.getItem('id_token_portalbitrix')
    haaId.value = localStorage.getItem('haaid')
    var headers = {
        Authorization: 'Bearer ' + salesPersonbitrix.value
    }
    var data = {}
    axios.post(import.meta.env.VITE_BITRIXAPI + 'partner/payproff/verify', data, { headers })
        .then(
            response => {
                var res = response.data.data
                verifylink.value = res.url
                isverified.value = true
            },
            response => {
                var error = response.data.message
                googlechaterror('Partner verify api' + error + '')
            }
        )
}

function getwalletinfo () {
    salesPersonbitrix.value = localStorage.getItem('id_token_portalbitrix')
    var headers = {
        Authorization: 'Bearer ' + salesPersonbitrix.value
    }
    var data = {}
    axios.get(import.meta.env.VITE_BITRIXAPI + 'partner/payproff/wallet', { headers }, data).then(
        (response) => {
            var res = response.data.data
            partnerwallet.value = res
        },
        (response) => {
            console.error(response.data.message)
        }
    )
}

function updateiban () {
    if (!partnerwallet.value) {
        console.error('Din tegnebog er konfigureret korrekt, kontakt venligst support for yderligere hjælp')
        return false
    }
    if (!partneriban.value) {
        console.error('Tilføj venligst dit Iban-nummer')
        return false
    }
    disablebutton.value = true
    salesPersonbitrix.value = localStorage.getItem('id_token_portalbitrix')
    var headers = {
        Authorization: 'Bearer ' + salesPersonbitrix.value
    }
    var data = {
        iban: selectedCountry.value + partneriban.value,
        walletid: partnerwallet.value['WALLET_ID']
    }
    axios.put(import.meta.env.VITE_BITRIXAPI + 'partner/payproff/wallet', data, { headers }).then(
        (response) => {
            if (verifylink.value) {
                showlink(verifylink.value)
            } else {
                getNemIdUrl()
            }
            updateStatus('clicked')
            disablebutton.value = false
            isverified.value = false
        },
        (response) => {
            disablebutton.value = false
            console.error(response.data.message)
        }
    )
}

function verifylinks () {
    if (verifylink.value) {
        showlink(verifylink.value)
    } else {
        getNemIdUrl()
    }
}

function verifyIban (ibantext) {
    salesPersonbitrix.value = localStorage.getItem('id_token_portalbitrix')
    var headers = {
        Authorization: 'Bearer ' + salesPersonbitrix.value
    }
    var data = {}
    axios.get(import.meta.env.VITE_BITRIXAPI + 'helper/validateIban/' + selectedCountry.value + partneriban.value.replace(/ /g, '').replace('DK', ''), { headers }, data).then(
        (response) => {
            var res = response.data
            if (res.data.valid) {
                if (ibantext === '') {
                    registerpayproff()
                }
                ibanmessage.value = null
            } else {
                var messagearr = ''
                res.data.messages.forEach(t => {
                    messagearr += t + ', '
                })
                ibanmessage.value = messagearr
                console.error(messagearr)
            }
        },
        (response) => {
            console.error(response.data.message)
        }
    )
}

function getPayproffacc () {
    salesPersonbitrix.value = localStorage.getItem('id_token_portalbitrix')
    var headers = {
        Authorization: 'Bearer ' + salesPersonbitrix.value
    }
    var data = {}
    axios.post(import.meta.env.VITE_BITRIXAPI + 'partner/payproff/account/exists/', data, { headers }).then(
        response => {
            var res = response.data
            var verifyongoing = false
            haspayproff.value = res.data.exists
            payproffemail.value = res.data.email
            ispartnerpayproffverified.value = res.data.payproff_verified
            verifylink.value = res.data.payproff_url
            clickdate.value = res.data.status_updated
            const datenow = new Date()
            const processingstart = new Date(res.data.status_updated)
            const processingend = new Date(res.data.status_updated)
            processingend.setDate(processingstart.getDate() + 3)
            if (datenow.getTime() >= processingstart.getTime() && datenow.getTime() <= processingend.getTime()) {
                verifyongoing = true
            }
            if (!verifylink.value && !ispartnerpayproffverified.value && !verifyongoing) {
                verifypartner()
            } else if (verifylink.value && !ispartnerpayproffverified.value && !verifyongoing) {
                isverified.value = true
            }
            getwalletinfo()
        },
        response => {
            console.error(response.data.message)
        })
}

function googlechaterror (message, projectid = 0) {
    haaId.value = localStorage.getItem('haaid')
    var decription = '``` ' + message + ':  Partner = ' + haaId.value + ' payproff Email= ' + payproffemail.value + ' projectid = ' + projectid + ' in ' + import.meta.env.VITE_BITRIXAPI + ' ```'
    var messagetext = {'text': decription}
    var data = JSON.stringify(messagetext)
    var url = 'https://chat.googleapis.com/v1/spaces/AAAAvk37NDw/messages?key=AIzaSyDdI0hCZtE6vySjMm-WEfRq3CPzqKqqsHI&token=N_Q5LGhTus51HJ_-JfKXcY3Qi4_gS-loQpY6MZd03do'
    axios.post(url, data)
        .then(
            response => {},
            response => {}
        )
}

function updateStatus (buttonstatus) {
    salesPersonbitrix.value = localStorage.getItem('id_token_portalbitrix')
    var headers = {
        Authorization: 'Bearer ' + salesPersonbitrix.value
    }
    var data = {
        status: buttonstatus
    }
    axios.post(import.meta.env.VITE_BITRIXAPI + 'partner/payproff/updateStatus', data, { headers }).then(
        response => {
            if (!partnerwallet.value || partnerwallet.value.IBAN === null || partnerwallet.value.IBAN === '') {
                updateiban()
            } else {
                verifylinks()
            }
        },
        response => {
            console.error(response.data.message)
        })
}

function getNemIdUrl () {
    salesPersonbitrix.value = localStorage.getItem('id_token_portalbitrix')
    var headers = {
        Authorization: 'Bearer ' + salesPersonbitrix.value
    }
    var data = {}
    axios.post(import.meta.env.VITE_BITRIXAPI + 'partner/payproff/verify', data, { headers }).then(
        response => {
            var res = response.data
            window.open(res.data.URL, '_blank').focus()
        },
        err => {
            console.error(err)
        }
    )
}

function setmaskinput () {
    if (partneriban.value.length > 18) {
        verifyIban('checkiban')
    }
}

defineExpose({ getPayproffacc })
</script>
<style scoped>
#isverified .modal-dialog {
  top: 20%;
}
</style>
